import React, { useEffect, useState } from 'react';
import { Button, Col, Row, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
import viewIcon from '../../assets/images/icons/viewModalIcon.svg';
import * as _ from 'lodash';
import ReactSelect from 'react-select';
import DataTable from 'react-data-table-component';
import moment from 'moment';
import { useAuth } from '../../hooks/useAuth';
import { PDFDownloadLink } from '@react-pdf/renderer';
import FavouriteTripsPdf from './FavouriteTrips';

const customStyles = {
    rows: {
        style: {
            // minHeight: '72px' // override the row height
            textAling: 'center'
        }
    },
    headCells: {
        style: {
            paddingLeft: '8px', // override the cell padding for head cells
            paddingRight: '8px',
            backgroundColor: '#13aa61',
            color: 'white',
            '&:hover': {
                cursor: 'pointer'
            }
        }
    }
};
let allowedKeysFavourite = {
    Commuter: 'commuter',
    'Agency Name': 'transit_agency',
    'Transit Type': 'transit_type',
    'Starting Station': 'starting_station',
    'Ending Station': 'last_station',
    'Points Earned': 'points_earned',
    Frequency: 'route_count'
};
let allowedKeys = {
    Commuter: 'commuter',
    'Agency Name': 'transit_agency',
    'Transit Type': 'transit_type',
    'Starting Station': 'starting_station',
    'Ending Station': 'last_station',
    'Points Earned': 'points_earned'
};

const RouteDetail = (props) => {
    const [data, setData] = useState();
    const location = useLocation();
    const [vendorListing, setVendorListing] = useState([]);
    const [allUnits, setAllUnits] = useState('');
    const [stationListing, setStationListing] = useState([]);
    const { getToken } = useAuth();
    const { state } = location;
    const navigate = useNavigate();
    const [allTripsFavouritePdf, setAllTripsFavouritePdf] = useState([]);
    const [allTripsPdf, setAllTripsPdf] = useState([]);
    useEffect(() => {
        if (state?.route_id) {
            getRouteDetails(state?.route_id);
            getMeasuredUnits();
        }
    }, []);

    const getRouteDetails = async (id = '') => {
        const token = getToken();
        if (token && id) {
            new WebApiCalls()
                .getSingleRoute(token, id)
                .then((res) => {
                    if (res?.code == 200) {
                        setData(res.data);
                        setVendorListing(res?.data?.vendors);
                        setStationListing(res?.data?.stations);
                    }
                })
                .catch((err) => {});
        }
    };
    const getMeasuredUnits = async () => {
        const token = getToken();
        if (token) {
            new WebApiCalls()
                .getRewardSettings(token)
                .then((res) => {
                    if (res?.code == 200) {
                        setAllUnits(res?.data);
                    }
                })
                .catch((err) => {});
        }
    };
    const getAllTripsFavouritePdf = async () => {
        const token = getToken();
        if (token) {
            new WebApiCalls()
                .getAllTripsPdf(token, state?.route_id, true)
                .then((res) => {
                    if (res?.code == 200) {
                        setAllTripsFavouritePdf(res);
                    }
                })
                .catch((err) => {});
        }
    };
    const getAllTripsPdf = async () => {
        const token = getToken();
        if (token) {
            new WebApiCalls()
                .getAllTripsPdf(token, state?.route_id, 'all')
                .then((res) => {
                    if (res?.code == 200) {
                        setAllTripsPdf(res);
                    }
                })
                .catch((err) => {});
        }
    };

    useEffect(() => {
        if (state?.route_id) {
            getAllTripsFavouritePdf();
            getAllTripsPdf();
        }
    }, [state?.route_id]);

    const vendorColumns = [
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Logo</span>
                </h6>
            ),
            selector: (row) => <img className="img-fluid  table-image" src={row?.logo} />,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Name</span>
                </h6>
            ),
            selector: (row) => row.name,
            center: true
        },

        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Location</span>
                </h6>
            ),
            selector: (row) => row?.location,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Phone</span>
                </h6>
            ),
            selector: (row) => row?.phone_no,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Available Rewards</span>
                </h6>
            ),
            selector: (row) => row?.available_rewards || 0,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Status</span>
                </h6>
            ),
            selector: (row) => (
                <select
                    disabled={true}
                    value={row?.status}
                    className={row.status == 'active' ? 'status-selector' : 'status-selector-inactive'}
                    aria-label="Default select example"
                >
                    <option value={'active'}>Active</option>
                    <option value={'inactive'}>Inactive</option>
                </select>
            ),
            center: true
        }
    ];

    const stationColumns = [
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Name</span>
                </h6>
            ),
            selector: (row) => row?.name,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Latitude</span>
                </h6>
            ),
            selector: (row) => row.lat
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Longitude</span>
                </h6>
            ),
            selector: (row) => row?.long
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Action</span>
                </h6>
            ),
            selector: (row) => (
                <div className="d-flex">
                    <div className="view-detail">
                        <OverlayTrigger placement={'bottom'} overlay={<Tooltip id={`tooltip-bottom`}>View details</Tooltip>}>
                            <div className="edit-detail">
                                <img
                                    width={15}
                                    className="me-3"
                                    src={viewIcon}
                                    alt=""
                                    onClick={() => {
                                        navigate('/stops/stop-detail', {
                                            state: {
                                                station_id: row?._id,
                                                route_id: state?.route_id,
                                                redirect_url: '/routes/route-detail'
                                            }
                                        });
                                    }}
                                />
                            </div>
                        </OverlayTrigger>
                    </div>
                </div>
            ),
            center: true
        }

        // {
        //     name: (
        //         <h6 className="text-capitalize mt-2 text-center">
        //             <span className="fw-bold">Status</span>
        //         </h6>
        //     ),
        //     selector: (row) => (
        //         <select disabled={true} value={row?.status}
        //             className={row.status == 'active' ? "status-selector" : 'status-selector-inactive'}
        //             aria-label="Default select example">
        //             <option value={'active'}>Active</option>
        //             <option value={'inactive'}>Inactive</option>
        //         </select>
        //     ),
        //     center: true
        //     sortable: true
        // }
    ];

    return (
        <>
            <Row className="justify-content-end align-items-center">
                <Col sm={8} md={8} className="text-center ">
                    <div className="d-flex align-items-center justify-content-end gap-2">
                        {data && allUnits && allTripsPdf?.code === 200 && (
                            <PDFDownloadLink
                                document={<FavouriteTripsPdf data={data} allUnits={allUnits} allTripsPdf={allTripsPdf?.data} allowedKeys={allowedKeys} />}
                                fileName="trips.pdf"
                            >
                                <Button className="export-file justify-content-center  align-items-center" style={{ background: '#198754', minWidth: '250px' }}>
                                    Export Trips
                                </Button>
                            </PDFDownloadLink>
                        )}
                        {data && allUnits && allTripsFavouritePdf?.code === 200 && (
                            <PDFDownloadLink
                                document={
                                    <FavouriteTripsPdf data={data} allUnits={allUnits} allTripsPdf={allTripsFavouritePdf?.data} allowedKeys={allowedKeysFavourite} />
                                }
                                fileName="favourite_trips.pdf"
                            >
                                <Button className="export-file justify-content-center  align-items-center" style={{ background: '#198754', minWidth: '250px' }}>
                                    Export Favourite Trips
                                </Button>
                            </PDFDownloadLink>
                        )}
                        <Link to="/routes">
                            <Button className="theme-cancel-btn px-5 py-2">Close</Button>
                        </Link>
                    </div>
                </Col>
            </Row>
            {/* <Row>
                <Col sm={4}>
                    <div className="detail-heading ms-5">Route Details</div>
                </Col>
            </Row> */}
            <Row className="d-flex justify-content-center">
                <Col xs={12} sm={12} md={12} lg={12} className="p-4 m-3 ">
                    <Row>
                        <Col sm={6} md={3} className="mb-1">
                            <div className="detail-image-container">
                                {data?.transit_agency?.logo ? <img src={data?.transit_agency?.logo} alt="logo-img" /> : <span>No image selected for the agency</span>}
                            </div>
                        </Col>
                        <Col sm={6} md={9} className="mb-1">
                            <Row>
                                <Col sm={6} md={3} className="mb-4">
                                    <div className="detail-small-heading">Name</div>
                                    <div className="detail-value">{data?.name}</div>
                                </Col>

                                <Col sm={6} md={2} className="mb-4">
                                    <div className="detail-small-heading">Transit Type</div>
                                    <div className="detail-value">{_.capitalize(data?.transit_type)}</div>
                                </Col>

                                <Col sm={6} md={2} className="mb-4">
                                    <div className="detail-small-heading">Total Retailers</div>
                                    <div className="detail-value">{data?.noOfVendors}</div>
                                </Col>

                                <Col sm={6} md={2} className="mb-4">
                                    <div className="detail-small-heading">Total Stations</div>
                                    <div className="detail-value">{data?.noOfStations}</div>
                                </Col>

                                <Col sm={6} md={3} className="mb-4">
                                    <div className="detail-small-heading">Length of Route</div>
                                    <div className="detail-value">
                                        {data?.length}
                                        {allUnits?.distanceUnit}
                                    </div>
                                </Col>

                                <Col sm={6} md={4} className="mb-4">
                                    <div className="detail-small-heading">Daily Average Commuters</div>
                                    <div className="detail-value">{Math.ceil(data?.avgDailyCommuter)}</div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <hr className="mt-3" />
                    <Row className="mt-4">
                        <Col md={4}>
                            <div className="detail-value mb-4">Vendor Listing</div>
                        </Col>
                    </Row>

                    <Row>
                        <DataTable
                            columns={vendorColumns}
                            data={vendorListing}
                            // selectableRows
                            responsive
                            // pagination
                            // paginationServer
                            // paginationTotalRows={totalRecords}
                            // onChangeRowsPerPage={handlePerRowsChange}
                            // onChangePage={handlePageChange}
                            // responsive
                            // direction="auto"
                            // fixedHeaderScrollHeight="300px"
                            // subHeaderAlign="right"
                            // subHeaderWrap
                            customStyles={customStyles}
                            // onSelectedRowsChange={handleRowSelected}
                            // clearSelectedRows={toggleCleared}
                            // defaultSortFieldId={1}
                        />
                    </Row>
                    {/* <hr className="mt-3" />
                    <Row className="mt-4">
                        <Col md={4}>
                            <div className="detail-value mb-4">Stations Listing</div>
                        </Col>
                    </Row>

                    <Row>
                        <DataTable
                            columns={stationColumns}
                            data={stationListing}
                            responsive
                            customStyles={customStyles}
                            // selectableRows
                            // pagination
                            // paginationServer
                            // paginationTotalRows={totalRecords}
                            // onChangeRowsPerPage={handlePerRowsChange}
                            // onChangePage={handlePageChange}
                            // responsive
                            // direction="auto"
                            // fixedHeaderScrollHeight="300px"
                            // subHeaderAlign="right"
                            // subHeaderWrap
                            // onSelectedRowsChange={handleRowSelected}
                            // clearSelectedRows={toggleCleared}
                            // defaultSortFieldId={1}
                        />
                    </Row> */}
                </Col>
            </Row>
        </>
    );
};

export default RouteDetail;
